<script>
import { totalSeconds } from '../variables.js';

export default {
  name: 'AudioPlayerTimelineHotspot',
  props: {
      position: 0,
      duration: 0,
  },
  methods: { },
  computed: {
    percentagePosition() {
      return this.position / totalSeconds * 100 + '%';
    },
    percentageWidth() {
      return this.duration / totalSeconds * 100 + '%';
    }
  }

};
</script>

<template>
  <div class="hotspot" v-bind:style="{ left: percentagePosition, width: percentageWidth }"></div>
</template>

<style lang="scss" scoped>
$hotspot-base: 1.5rem;
$hotspot-pin-base: #{$hotspot-base * .42};
$hotspot-pin-half-base: #{($hotspot-base * .42) * -.5};

.hotspot {
  position: absolute;
  height: $hotspot-base;
  bottom: 0;
  margin: 0 #{$hotspot-base * -.5};
  padding: 0 #{$hotspot-base * .5};
  background: #E2A05A;
  border-radius: $hotspot-base;
  mix-blend-mode: multiply;
}
.hotspot:before,
.hotspot:after {
  content: "";
  position: absolute;
  width: $hotspot-pin-base; height: $hotspot-pin-base;
  top: #{$hotspot-base * .7};
  margin: 0 $hotspot-pin-half-base;
  background: #E2A05A;
  transform: rotate(45deg);
}
.hotspot:before {
  left: #{$hotspot-base * .5};
}
.hotspot:after {
  right: #{$hotspot-base * .5};
}
</style>
